import React from 'react';
import { RichTextField } from '@/components/form/fields/RichTextField';
import { InputField } from '@/components/form/fields/InputField';
import {
  SelectField,
  ISelectOption,
} from '@/components/form/fields/SelectField';
import { UploadField } from '@/components/form/fields/UploadField';

export const CreateResultForm: React.FC = () => {
  const statusOptions: ISelectOption[] = [
    { label: 'Passed', value: 'PASSED' },
    { label: 'Untested', value: 'UNTESTED' },
    { label: 'Blocked', value: 'BLOCKED' },
    { label: 'Retest', value: 'RETEST' },
    { label: 'Failed', value: 'FAILED' },
    { label: 'Not Applicable', value: 'NOT_APPLICABLE' },
    { label: 'In Progress', value: 'IN_PROGRESS' },
    { label: 'Hold', value: 'HOLD' },
  ];

  return (
    <div>
      <div className="flex gap-5">
        <SelectField
          options={statusOptions}
          name="status"
          label="Status"
          hasRequiredAsterisk
          isSearchable
        />

        <InputField
          name="time_spend"
          label="Time Spend"
          placeholder="Time Spend"
        />
      </div>

      <div className="mt-4">
        <RichTextField
          name="comment_test"
          label="Comment"
          placeholder="Write result notes (e.g. Actual, Expected, Notes)..."
          hasRequiredAsterisk
        />
      </div>

      <div className="mt-3">
        <UploadField
          name="medias"
          note="File size should be less than 2MB and allowed formats are .xls, .xlsx, .doc, .txt, .pdf, .csv, .log, .zip, .mp4, .webm, .ipynb, .odf, .gif, .png, .jpg, .ppt, .pptx, .mov"
          type="file"
          isMultiple
        />
      </div>
    </div>
  );
};
